(async () => {
  if (!customElements.get("featured-collections-swiper")) {
    const {
      default: Swiper,
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay,
    } = await import("swiper");

    Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

    class FeaturedCollections extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector(
          "[data-swiper-featured-collections]"
        );
        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 2,
          direction: "horizontal",
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          window.addEventListener("shopify:section:load", () => {
            this.swiperInstance.update();
          });
        }
        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(
          this.swiperElement,
          this.swiperOptions
        );
      }
    }

    window.FeaturedCollections = FeaturedCollections;

    customElements.define("featured-collections-swiper", FeaturedCollections);
  }
})();
